import React from 'react'
import { connect } from 'react-redux'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { FatFingerDetail, CrudEventEnum, CrudActions } from 'api'
import { NotificationType, NotificationActions, ShowDialogArgs } from 'store/notification'
import { Translation, Locale } from 'locale'
import { FatFingerDialog } from '../FatFingerDialog'

export interface FatFingerActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<FatFingerDetail> {
  onShowDialog: (dialogArgs: ShowDialogArgs) => unknown
}

const mapStateToProps = null

const mapDispatchToProps = {
  onShowDialog: NotificationActions.showDialog
}

export class FatFingerActionsButtonComponent extends React.Component<FatFingerActionsButtonProps> {
  render() {
    const viewItems = this.props.items.filter(item => !this.canEditDetails(item))
    const editItems = this.props.items.filter(item => this.canEditDetails(item))
    const deleteItems = this.props.items.filter(item => this.canDelete(item))

    const actions: ActionItem[] = [
      {
        label: this.getLabel(Translation.TC_ACTION_VIEW_DETAILS, 1),
        onClick: () => this.handleShowItemDialog(viewItems),
        enabled: viewItems.length === 1
      },
      {
        label: this.getLabel(Translation.TC_ACTION_EDIT_DETAILS, 1),
        onClick: () => this.handleShowItemDialog(editItems),
        enabled: editItems.length === 1
      },
      {
        label: this.getLabel(Translation.TC_ACTION_DELETE, deleteItems.length),
        onClick: () => this.handleDelete(deleteItems),
        enabled: deleteItems.length > 0
      }
    ]
    return <SplitButtonDropdown dataTestId={'FatFingerActionsButton'} actions={actions} maxButtons={1} autoHideEllipsis={true} />
  }

  private getLabel = (baseLabel: Translation, count: number) => {
    const { isGroupRow } = this.props
    const countLabel = isGroupRow ? ` (${count})` : ``
    return `${Locale.translate(baseLabel)}${countLabel}`
  }

  private handleShowItemDialog = (items: FatFingerDetail[]) => {
    this.props.showModal(<FatFingerDialog fatFingerDetail={items[0]} />)
  }

  private handleDelete = async (items: FatFingerDetail[]) => {
    const titleText = Locale.translate(Translation.TC_PROMPT_TITLE_DELETE_FAT_FINGER_LIMIT, { count: items.length })
    const messageText =
      items.length === 1
        ? Locale.translate(Translation.SC_PROMPT_MSG_DELETE_SINGLE_FAT_FINGER_LIMIT, {
            name: items[0].productSector ? items[0].productSector.name : items[0].fatFinger.productSectorId
          })
        : Locale.translate(Translation.SC_PROMPT_MSG_DELETE_MULTI_FAT_FINGER_LIMIT, { count: items.length })

    const deleteActions = items.map(item => CrudActions.fatFingerDelete(item.fatFinger.productSectorId))

    this.props.onShowDialog({
      type: NotificationType.Confirm,
      titleText,
      messageText,
      buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
      defaultButton: Translation.TC_BUTTON_YES,
      cancelButton: Translation.TC_BUTTON_NO,
      responseMap: {
        [Translation.TC_BUTTON_YES]: deleteActions
      }
    })
  }

  private canEditDetails = (item: FatFingerDetail) => {
    return item.availableEvents.includes(CrudEventEnum.UPSERT)
  }

  private canDelete = (item: FatFingerDetail) => {
    return item.availableEvents.includes(CrudEventEnum.DELETE)
  }
}

export const FatFingerActionsButton = withModal(connect(mapStateToProps, mapDispatchToProps)(FatFingerActionsButtonComponent))
